import React, { Component } from 'react';

import "./Readmore-Video.scss"
import handImage from "../../../../static/images/new/hand.png"

class ReadmoreVideo extends Component {
  constructor() {
    super();
    this.isItExplorer = this.isItExplorer.bind(this);
    this.state = {
      explorer: ""
    }
  }
  isItExplorer() {
    if (navigator.userAgent.indexOf("Edge") > -1 ||
      navigator.userAgent.indexOf("Trident") > -1 ||
      navigator.userAgent.indexOf("MSIE") > -1) {
      this.setState({
        explorer: " iefix"
      })
    }
  }
  componentDidMount() {
    this.isItExplorer();
  }
  render() {
    const hand = {
      backgroundImage: "url(" + handImage + ")"
    }
    return (
      <div className={"video " + this.state.explorer}>
        <div className="headline">
          <h4>{this.props.data.headline}</h4>
        </div>
        <div className="hand" style={hand}></div>
        <div className="videoiframe">
          <iframe src={this.props.data.link} frameBorder="0" title="Video" gesture="media" allow="encrypted-media" allowFullScreen mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
        </div>
      </div>
    );
  }
}

export default ReadmoreVideo;



// WEBPACK FOOTER //
// ./src/components/Readmore/components/Readmore-Video/Readmore-Video.js